import { cn } from "../../../utils/tailwindUtils";

// Primary call-to-action styling, matched to the project theme (same as the
// DialogModal save button / ModuleTitleCard add button — sidebar teal).
export const PRIMARY_BTN =
    "bg-sidebar text-white hover:bg-sidebar-primary border border-sidebar-primary " +
    "dark:bg-sidebar-primary dark:hover:bg-sidebar-primary/90 focus-visible:ring-sidebar-primary";

// A consistent action bar pinned to the bottom of the (scrolling) card. Always
// has a solid surface so the page background never bleeds through behind it.
export const WizardFooter = ({ children, className }) => (
    <div
        className={cn(
            "sticky bottom-0 flex flex-wrap justify-end gap-3 px-4 py-3",
            "border-t border-gray-200 dark:border-gray-700",
            "bg-white dark:bg-gray-800 rounded-b-xl",
            className
        )}
    >
        {children}
    </div>
);
